import { Injectable } from '@angular/core';
import { NativeBridgeService } from './native-bridge.service';
import { deviceMessageId } from '../enums/device-message-id.enum';
import { NotificationService } from './notification.service';
import { PrintResumenClover } from '../models/interfaces/print-resumen-clover';

@Injectable({
  providedIn: 'root'
})
export class PrintLotClosureService {
  constructor(private nativeBridgeService: NativeBridgeService, private notificationService: NotificationService) {}

  sendLotClosureToDevice(terminalId: string, resumen: any) {
    const resumenToSend: PrintResumenClover = {
      message_id: deviceMessageId.PRINT_LOT_CLOSURE,
      from: resumen.desde,
      to: resumen.hasta,
      user: resumen.user,
      terminal_id: terminalId,
      total_movements: resumen.totalMovimientosPix,
      total_amount: resumen.totalRecaudado,
      current_date: resumen.currentDate,
      current_time: resumen.currentDateTime,
      all_terminals: resumen.allTerminals
    };
    try {
      this.nativeBridgeService.sendMessageToDevice(JSON.stringify(resumenToSend));
      this.notificationService.showSuccess('Imprimiendo resumen de operaciones');
    } catch (error) {
      this.notificationService.showError('Error al imprimir resumen de operaciones');
    }
  }
}
